import { render, staticRenderFns } from "./ed-add-menu-options.vue?vue&type=template&id=4b1c9c3f&scoped=true&"
import script from "./ed-add-menu-options.ts?vue&type=script&lang=js&"
export * from "./ed-add-menu-options.ts?vue&type=script&lang=js&"
import style0 from "./ed-add-menu-options.scss?vue&type=style&index=0&id=4b1c9c3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c9c3f",
  null
  
)

export default component.exports